function updateIngredientsArrows(carousel) {
  const track = carousel.querySelector('.kr-ingredients-grid');
  const prev = carousel.querySelector('.kr-ingredients-arrow--prev');
  const next = carousel.querySelector('.kr-ingredients-arrow--next');

  if (!track || !prev || !next) return;

  const maxScroll = track.scrollWidth - track.clientWidth;

  prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
  next.classList.toggle('is-disabled', track.scrollLeft >= maxScroll - 2);
}

function initIngredientsCarousels() {
  document.querySelectorAll('.kr-ingredients-carousel').forEach((carousel) => {
    updateIngredientsArrows(carousel);

    const track = carousel.querySelector('.kr-ingredients-grid');

    if (track) {
      track.addEventListener('scroll', function () {
        updateIngredientsArrows(carousel);
      });
    }
  });
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('.kr-ingredients-arrow');
  if (!button) return;

  const carousel = button.closest('.kr-ingredients-carousel');
  const track = carousel?.querySelector('.kr-ingredients-grid');

  if (!carousel || !track) return;

  const card = track.querySelector('.kr-ingredient-card');
  const gap = 16;
  const scrollAmount = card ? card.offsetWidth + gap : 250;

  track.scrollBy({
    left: button.classList.contains('kr-ingredients-arrow--next')
      ? scrollAmount
      : -scrollAmount,
    behavior: 'smooth',
  });

  setTimeout(function () {
    updateIngredientsArrows(carousel);
  }, 300);
});

document.addEventListener('DOMContentLoaded', function () {
  initIngredientsCarousels();

  setTimeout(initIngredientsCarousels, 500);
});